export default class ElementBreite {
  static EIN_SECHSTEL = 1;

  static ZWEI_SECHSTEL = 2;

  static DREI_SECHSTEL = 3;

  static VIER_SECHSTEL = 4;

  static FUENF_SECHSTEL = 5;

  static SECHS_SECHSTEL = 6;

  static BREITEN = [
    this.EIN_SECHSTEL,
    this.ZWEI_SECHSTEL,
    this.DREI_SECHSTEL,
    this.VIER_SECHSTEL,
    this.FUENF_SECHSTEL,
    this.SECHS_SECHSTEL,
  ];

  static isValidWidth(width) {
    return this.BREITEN.includes(width);
  }
}
